(function () {
    "use strict";

    // @ngInject
    function CompanySettingsPricingControllerCtor($scope, $injector, AnalyticsService, FacebookPixelTrackingService, UsersManager) {
        this.constructor.$super.call(this, $scope, $injector);
        this.__objectType = 'CompanySettingsPricingController';
        var currUser = UsersManager.getCurrUser();
        AnalyticsService.trackPageView(this, 'company setting membership tab');
        FacebookPixelTrackingService.track('InitiateCheckout');

    }

    Controllers.CompanySettingsPricingController = Class(Controllers.BaseController, {
        constructor: CompanySettingsPricingControllerCtor
    });
}());
